import Vue from 'vue';
import Toasted from 'vue-toasted';

Vue.use(Toasted);

function showSuccessMessage(message: string) {
  Vue.toasted.success(message, {
    position: 'top-right',
    duration: 1000 * 5,
    action: {
      text: '✕',
      onClick: (e, toastObject) => {
        toastObject.goAway(0);
      },
    },
  });
}

function showErrorMessage(message: string) {
  Vue.toasted.error(message, {
    position: 'top-right',
    // duration: 1000 * 5,
    action: {
      text: '✕',
      onClick: (e, toastObject) => {
        toastObject.goAway(0);
      },
    },
  });
}

export const toasted = {
  showSuccessMessage,
  showErrorMessage,
};
